import {
  SET_CODE_SETTINGS,
  UPDATE_FCL_COUNTER,
  UPDATE_LCL_SHIPMENT,
  UPDATE_AIR_SHIPMENT,
  RESET_CONTAINER_TYPE_SLIDER,
  SET_RECAPTCHA_RES_CODE,
  SET_DATA_POLLING,
  SET_FORM_ZIPCODE_LOADING,
  SET_OVERLAY_FULL_SCREEN,
  SET_OVERLAY_PROGRESS,
  SET_TRANSPARENT_OVERLAY_SCREEN,
  UPDATE_SIDEBAR_ROLE_INCOTERM_SERVICES,
  UPDATE_PARENT_SCROLLBAR_POSITION,
  UPDATE_RATE_CARD_INFO,
  SHOW_SEARCH_BLUR_CARDS,
  UPDATE_FCL_CONTAINER_WEIGHTS,
  UPDATE_TRANSACTION_TYPE
  // SET_AIR_SLIDER_LOADING,
} from './types';

// import { isDevENV } from '../util/isDevENV';
import { isEmpty } from '../util/isEmpty';
// import { updateErrorAndLoading } from './route_actions';

/**
 * @module code_config_action
 * @redux
 * @description These are redux action creators related to web app configuration.
 */

/**
 * @function
 * @name saveCodeSettings
 * @description It's for updating height of [Search bar]{@Link Searchbar} height.
 * @param {number} data - height of search bar height
 * @returns {Redux.Action} The generated action
 */
export const saveCodeSettings = (data) => (dispatch) => {
  // console.log("saveCodeSettings: ", data);
  dispatch({ type: SET_CODE_SETTINGS, payload: data });
};

/**
 * @function
 * @name updateFclCounters
 * @description It updates selected FCL types of container numbers in [Sidebar]{@Link FCLContainerType}.
 * @param {Object} data - contains how many container is selected i.g. `{ _20stCounter: 2 }`
 * @returns {Redux.Action} The generated action
 */
export const updateFclCounters = (data) => (dispatch) => {
  // console.log("updateFclCounters: ", data);
  dispatch({ type: UPDATE_FCL_COUNTER, payload: data });
};

/**
 * @function
 * @name updateFclContainerWeights
 * @description It updates selected FCL types of container weights in [Sidebar]{@Link FCLContainerType}.
 * @param {Object} data - contains how much weight is selected i.g. `{ _20stWeight: 2 }`
 * @returns {Redux.Action} The generated action
 */
export const updateFclContainerWeights = (data) => (dispatch) => {
  dispatch({ type: UPDATE_FCL_CONTAINER_WEIGHTS, payload: data });
};

/**
 * @function
 * @name updateTransactionType
 * @description It updates transaction type in [Sidebar]{@Link FCLContainerType}.
 * @param {Object} data - type of transaction
 * @returns {Redux.Action} The generated action
 */
export const updateTransactionType = (data) => (dispatch) => {
  dispatch({ type: UPDATE_TRANSACTION_TYPE, payload: data });
};

/**
 * @function
 * @name updateLclShipment
 * @description It's for updating LCL shipment in [Search bar]{@Link LclAirSlider}.
 * @param {Object} data - contains shipment info i.g. `{ totalWeight: 5 }` , `{ weightUnit: 'KG' }`
 * @returns {Redux.Action} The generated action
 */
export const updateLclShipment = (data) => (dispatch,getState) => {
  // console.log("updateLclShipment: ", data);
  if(data?.totalVolume){
     data.totalVolume = (data.totalVolume < getState()?.route?.USER_DETAILS?.minimumCbm ? (getState()?.route?.USER_DETAILS?.minimumCbm) : data.totalVolume)
  }
  dispatch({ type: UPDATE_LCL_SHIPMENT, payload: data });
};

/**
 * @function
 * @name updateAirShipment
 * @description It's for updating AIR shipment in [Search bar]{@Link LclAirSlider}.
 * @param {Object} data - contains shipment info i.g. `{ totalVolume: 6 }`
 * @returns {Redux.Action} The generated action
 */
export const updateAirShipment = (data) => (dispatch) => {
  // console.log("updateAirShipment: ", data);
  dispatch({ type: UPDATE_AIR_SHIPMENT, payload: data });
};

/**
 * @function
 * @name resetContainersTypeSliders
 * @description It resets selected [FCL container]{@Link FCLContainerType} and [LCL/AIR shipment]{@Link LclAirSlider} info in sidebar.
 * @returns {Redux.Action} The generated action
 */
export const resetContainersTypeSliders = () => (dispatch, getState) => {
  // console.log("resetContainersTypeSliders ");
 const minimumCbm = getState().route?.USER_DETAILS?.minimumCbm;
 const resetTotalVolume = minimumCbm > 1 ? minimumCbm : 1;
  dispatch({ type: RESET_CONTAINER_TYPE_SLIDER, payload: {resetTotalVolume} });
};

/**
 * @function
 * @name setReCaptchaCode
 * @description It saves google re-captcha response code.
 * @param {string} resCode - google re-captcha response code
 * @param {Function} callback - callback
 * @returns {Redux.Action} The generated action
 */
export const setReCaptchaCode = (resCode, callback) => (dispatch) => {
  dispatch({ type: SET_RECAPTCHA_RES_CODE, payload: resCode });
  if (callback) callback();
};

/**
 * @function
 * @name setDataPolling
 * @description it enables or disables capability of data polling (api request) by uuid on landing page
 * @param {boolean} shouldDataPoll - whether to disable capability of data polling
 * @param {Function} callback - callback
 * @returns {Redux.Action} The generated action
 */
export const setDataPolling = (shouldDataPoll, callback) => (dispatch) => {
  dispatch({ type: SET_DATA_POLLING, payload: shouldDataPoll });
  if (callback) callback();
};

/**
 * @function
 * @name setFormZipCodeSubmitLoading
 * @description It sets whether pickup/delivery should show loading on rate card on search page,
 * upon submit of Form zipcode submit for new/existing factory.
 * @param {Object} dataObj - contains whether pickup or delivery show a loader e.g `{isPickupLoading: true}`
 * @returns {Redux.Action} The generated action
 */
export const setFormZipCodeSubmitLoading = (dataObj) => (dispatch) => {
  dispatch({ type: SET_FORM_ZIPCODE_LOADING, payload: dataObj });
};

/**
 * @function
 * @name setOverlayFullScreen
 * @description It sets a full screen Overlay.
 * @param {boolean} shouldShowOverlay - whether to show full screen overlay
 * @returns {Redux.Action} The generated action
 */
export const setOverlayFullScreen = (shouldShowOverlay) => (dispatch) => {
  dispatch({ type: SET_OVERLAY_FULL_SCREEN, payload: shouldShowOverlay });
};

/**
 * @function
 * @name setOverlayProgress
 * @description Updates the full screen overlay progress percentage.
 * @param {number} progressValue - progress from 0 to 100
 * @returns {Redux.Action} The generated action
 */
export const setOverlayProgress = (progressValue) => (dispatch) => {
  dispatch({ type: SET_OVERLAY_PROGRESS, payload: progressValue });
};

/**
 * @function
 * @name setTransparentOverlay
 * @description It sets a full screen Overlay.
 * @param {boolean} saveDataShowOverlay - whether to show full screen overlay
 * @returns {Redux.Action} The generated action
 */
export const setTransparentOverlay = (saveDataShowOverlay) => (dispatch) => {
  dispatch({ type: SET_TRANSPARENT_OVERLAY_SCREEN, payload: saveDataShowOverlay });
};

/**
 * @function
 * @name updateSidebarRoleIncotermServices
 * @description  It updates states of sidebar service roles checkboxes on search page.
 * @param {Object} dataObj - contains checkbox states whether they are checked or not e.g. `{discharge: true}`
 * @returns {Redux.Action} The generated action
 */
export const updateSidebarRoleIncotermServices = (dataObj) => (dispatch) => {
  dispatch({ type: UPDATE_SIDEBAR_ROLE_INCOTERM_SERVICES, payload: dataObj });
};

/**
 * @function
 * @name updateParentScrollbarPosition
 * @description It's for parent website scrollbar position and used for margin-top of sailing schedule modal.
 * @param {number} relativeScrollPos - current scroll position w.r.t previous scroll position on parent website
 * @returns {Redux.Action} The generated action
 */
export const updateParentScrollbarPosition = (relativeScrollPos) => (
  dispatch,
  getState
) => {
  const oldScrollPos = getState().code_config.parentScrollbarPosition;
  dispatch({
    type: UPDATE_PARENT_SCROLLBAR_POSITION,
    payload: oldScrollPos + relativeScrollPos,
  });
};

/**
 * @function
 * @name updateRateCardsInfo
 * @description  it will contain rate cards state whether cards are expanded or not.
 * @param {Object} cardsInfoObj - contains which cards are expanded or not. `true` means the card is expanded, otherwise not.
 * e.g. `{ 75565: true }` - The rate card with `id` 75565 is expanded.
 * @returns {Redux.Action} The generated action
 */
export const updateRateCardsInfo = (cardsInfoObj) => (dispatch) => {
  dispatch({
    type: UPDATE_RATE_CARD_INFO,
    payload: !!cardsInfoObj && !isEmpty(cardsInfoObj) ? cardsInfoObj : {},
  });
};

/**
 * @function
 * @name showSearchBlurCards
 * @description It sets whether to show blur cards or not on search page
 * @param {boolean} shouldShow - should show blur cards or not
 * @returns {Redux.Action} The generated action
 */
export const showSearchBlurCards = (shouldShow) => (dispatch) => {
  dispatch({
    type: SHOW_SEARCH_BLUR_CARDS,
    payload: shouldShow,
  });
};
